// src/components/report_details/IPs/IPDetailInfo.tsx
import React from 'react';
import { IPDetail } from '../../../types/interfaces';
import IPInfo from './IPInfo';
import Vulnerabilities from './Vulnerabilities';

interface IPDetailInfoProps {
  ipDetail: IPDetail;
  onClose: () => void;
}

const IPDetailInfo: React.FC<IPDetailInfoProps> = ({ ipDetail, onClose }) => {
  const { ip, info, ports, vulnerabilities } = ipDetail;

  // Adaptar la info para IPInfo
  const ipInfoData = {
    ip,
    asn: info?.asn || '',
    ciudad: info?.city || '',
    latitud: info?.lat || null,
    longitud: info?.long || null,
    isp: info?.isp || '',
    ultima_actualizacion: info?.last_updated || '',
    pais: info?.country || '',
    sistema_operativo: info?.os || '',
    puertos: ports,
  };

  return (
    <div>
      <button
        onClick={onClose}
        className="bg-gray-800 text-white py-2 px-4 rounded-lg hover:bg-gray-600 transition-colors duration-300 flex items-center mb-4"
      >
        <span className="mr-2">←</span> Volver
      </button>
      <IPInfo ipData={ipInfoData} />
      <Vulnerabilities vulnerabilities={vulnerabilities} />
    </div>
  );
};

export default IPDetailInfo;
